import type { MoneyMapWithRulesAndAccounts } from '@fruitful/types';

import { requestBuilder } from '../../http/RequestBuilder';

export const getMoneyMapQueryKey = ({ id }: { id: string }): string =>
    `getMoneyMap/${id}`;

export const useGetMoneyMap = requestBuilder.query<
    MoneyMapWithRulesAndAccounts,
    { id: string }
>({
    endpoint: ({ id }) => `/api/money-map/${id}`,
    queryKey: getMoneyMapQueryKey,
});
